export default __webpack_public_path__ + "static/media/nbru_three.43f34b3a.png";